import styled from "@emotion/styled";

import { Checkbox as BaseCheckbox } from "shared/components/Form/Checkbox";

export const Checkbox = styled(BaseCheckbox)({
  display: "inline",
});
